import { Box, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import StepCard from "./StepCard";

const numCircle = {
  width: 56,
  height: 56,
  borderRadius: "56px",
  borderWidth: "5px",
  // backgroundColor: "#FFF8E1",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  // position: "relative",
  // zIndex: 2,
  // border: "5px solid #FFFFFF",

  // Gradiant
  cursor: "pointer",

  // We need Two layes => inside: yellow and outdide: gradiant
  background:
    "linear-gradient(#FFF8E1, #FFF8E1) padding-box, linear-gradient(90deg, transparent, transparent) border-box",
  border: "5px solid transparent",
  boxShadow: "0 0 10px 0 #0000000D",
  transition: "0.3s",
};

const number = {
  width: 28,
  height: 32,
  color: "#000000DE",
  fontSize: "1.5rem",
  fontWeight: 600,
  lineHeight: 1.3,

  // Gradiant
  transition: "0.3s",
};

const iconCircle = {
  width: 28,
  height: 28,
  borderRadius: "32px",
  border: "3px solid #E7E4FF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#fff",
};

const verticalLine = {
  width: "1px",
  height: "20px",
  backgroundColor: "#0000001F",
};

const MobileSteps = ({ stepsData }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {stepsData.map((step, index) => (
        <Box
          key={step.number}
          className="step-root" // Important for Gradinat
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Number + Card */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",

              // The folloing is needed for Gradiant
              cursor: "pointer",

              // Hove on Step
              "&:hover .circle": {
                background:
                  "linear-gradient(#FFF8E1, #FFF8E1) padding-box, linear-gradient(90deg, #FF7FAC, #5834BA) border-box",
              },

              "&:hover .number": {
                background: "linear-gradient(90deg, #FF7FAC, #5834BA)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              },
            }}
          >
            <Box className="circle" sx={numCircle}>
              <Typography className="number" sx={number}>
                {step.number}
              </Typography>
            </Box>

            {/* Vertical Line #01 */}
            <Box sx={verticalLine} />

            <Box sx={iconCircle}>
              <ExpandMoreIcon sx={{ color: "#0000008F" }} />
            </Box>

            {/* Vertical Line #02 */}
            <Box sx={verticalLine} />

            {/* Card Data */}
            <Box>
              <StepCard {...step} />
            </Box>

            {/* Vertical Line  #03 */}
            {index !== stepsData.length - 1 && <Box sx={verticalLine} />}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default MobileSteps;
